import {
  getBranchCategoryCollection,
  getSingleBranchCategory,
  addBranchCategory,
  updateBranchCategory,
  deleteBranchCategory,
} from "../../services/settings/settings_branch_category_service";
import { actionTypes } from "../action_types";

export const GetBranchCategoryCollection = () => (dispatch) => {
  return getBranchCategoryCollection().then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_CATEGORY_COLLECTION,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetSingleBranchCategory = (data) => (dispatch) => {
  return getSingleBranchCategory(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_CATEGORY_GET_SINGLE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const AddBranchCategory = (data) => (dispatch) => {
  return addBranchCategory(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_CATEGORY_ADD,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const UpdateBranchCategory = (data) => (dispatch) => {
  return updateBranchCategory(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_CATEGORY_UPDATE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};

export const DeleteBranchCategory = (data) => (dispatch) => {
  return deleteBranchCategory(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionTypes.REPORTS_SETTINGS_BRANCH_CATEGORY_DELETE,
        payload: resp.data !== null ? resp.data : [],
      });
    }
    return Promise.resolve(resp);
  });
};
